import React from 'react';
import { motion } from 'framer-motion';
import { FileSignature, UserCheck, Award, Calendar, Shield, Sparkles, ArrowRight } from 'lucide-react';
const reasons = [{
  icon: FileSignature,
  title: 'Fixed Price Promise',
  body: 'Whatever we quote on the kitchen table is what you pay. No day of install surprises. No variations on the day.'
}, {
  icon: UserCheck,
  title: 'On-Site Assessment First',
  body: 'No phone-script recommendations. We inspect the property, measure the spaces and explain the right system clearly.'
}, {
  icon: Award,
  title: 'Mitsubishi Electric Diamond Dealer',
  body: 'The highest tier of Mitsubishi installer accreditation in Australia. We are tested on installation quality every year.'
}, {
  icon: Calendar,
  title: '30+ Years, Same Family',
  body: 'Founded 1995, family run from Balcatta. We answer our phone and we still install across Perth every week.'
}, {
  icon: Shield,
  title: 'Workmanship Guarantee',
  body: 'If anything we installed fails because of our workmanship, you call us. We come back free.'
}, {
  icon: Sparkles,
  title: 'Clean Install Promise',
  body: 'Drop sheets down. Vacuum on departure. We treat your home like ours.'
}];
export function WhyLangler() {
  return <section className="bg-cream py-20 md:py-28 scroll-mt-24" data-id="element-783" data-mp="9r53hcbbi6ug">
      <div className="max-w-6xl mx-auto px-6" data-id="element-784" data-mp="17duak0kvn9n6">
        <div className="max-w-3xl mb-14" data-id="element-785" data-mp="17cj1bl8nx9oo">
          <div className="kicker mb-3" data-id="element-786" data-mp="12er6ojgmv9gs">Why Langler Air</div>
          <h2 className="text-3xl md:text-5xl font-bold text-ink-900 tracking-tight leading-tight" data-id="element-787" data-mp="12f9dub4u383h">
            Six things most Perth installers will not tell you.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-788" data-mp="so6cd87zsr3o">
          {reasons.map((reason, i) => {
          const Icon = reason.icon;
          return <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: i * 0.06
          }} className="lift-card bg-white rounded-2xl p-7 border border-stone-200" data-id="element-789" data-mp="1lckb5q6wnrga" data-mpi={i}>
                <div className="w-12 h-12 rounded-xl bg-brand-soft text-brand flex items-center justify-center mb-5" data-id="element-790" data-mp="2wxc31wo5y6xn">
                  <Icon size={22} strokeWidth={2} data-id="element-791" data-mp="2mx1reghs17kl" />
                </div>
                <h3 className="text-xl font-extrabold text-ink-900 tracking-tight leading-tight mb-3" data-id="element-792" data-mp="2myw97lxr4jkg">
                  {reason.title}
                </h3>
                <p className="text-sm text-stone-600 leading-relaxed" data-id="element-793" data-mp="l6gk17syv7hg">
                  {reason.body}
                </p>
              </motion.div>;
        })}
        </div>

        <div className="mt-12 flex flex-wrap items-center justify-between gap-6 pt-8 border-t border-stone-200" data-id="element-794" data-mp="2alr9ncf842as">
          <div className="text-sm text-stone-600" data-id="element-795" data-mp="25oirhbu2ry9j">
            Related:{' '}
            <a href="/ducted-air-conditioning/" className="text-brand font-semibold hover:underline" data-id="element-796" data-mp="2kcvjjxq1kwyr">
              Ducted Reverse Cycle Installation
            </a>{' '}
            ·{' '}
            <a href="/smart-zone/" className="text-brand font-semibold hover:underline" data-id="element-797" data-mp="2tbh1bqnow7yh">
              Smart Zone Control
            </a>{' '}
            ·{' '}
            <a href="/brand/mitsubishi-air-conditioner-perth/" className="text-brand font-semibold hover:underline" data-id="element-798" data-mp="33aptcdyzvci7">
              Mitsubishi Electric
            </a>
          </div>
          <a href="#quote-form" className="inline-flex items-center gap-2 text-brand font-semibold hover:underline" data-id="element-799" data-mp="18zb3zy9wbf2z">
            Get my free quote <ArrowRight size={14} data-id="element-800" data-mp="3r61j8myplgr6" />
          </a>
        </div>
      </div>
    </section>;
}